import Container from "../../components/Container"
import Title from "../../components/Title"
import Slider from "../../components/Slider"
import Card from "./components/Card"

import "./Cards.scss"

const cards = [
  {
    title: "Simule e conheça as condições",
    description: "Insira o CPF e informe dados básicos como: e-mail e celular.",
  },
  {
    title: "Explore as opções",
    description:
      "Analise as taxas, prazos e escolha a opção que cabe no seu bolso.",
  },
  {
    title: "Finalize a renegociação",
    description: "Feche o acordo de renegociação e volte a ter o nome limpo.",
  },
  {
    title: "Acompanhe seus acordos",
    description: "Acesse sua 2ª via e comprovantes através da área de acordos.",
  },
]

const sliderSettings = {
  slidesToShow: 1.4,
  responsive: [
    {
      breakpoint: 768,
    },
    {
      breakpoint: 10000,
      settings: "unslick",
    },
  ],
}
const Renegotiations = () => {
  return (
    <section className="landing-renegotiations">
      <Container>
        <Title>Saiba como renegociar dívidas no Itaú</Title>
      </Container>

      <div className="landing-renegotiations">
        <Slider content={cards} settings={sliderSettings}>
          {cards.map((card) => {
            return (
              <div key={card.title}>
                <Card content={card} />
              </div>
            )
          })}
        </Slider>
      </div>
    </section>
  )
}

export default Renegotiations
